"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var style_1 = require("./style");
var Tooltip = function (_a) {
    var childRef = _a.childRef, children = _a.children, content = _a.content;
    var _b = (0, react_1.useState)(false), showTooltip = _b[0], setShowTooltip = _b[1];
    var compareSize = function () {
        var element = childRef === null || childRef === void 0 ? void 0 : childRef.current;
        if (element) {
            var hasOverflowingChildren = element.offsetHeight < element.scrollHeight ||
                element.offsetWidth < element.scrollWidth;
            setShowTooltip(hasOverflowingChildren);
        }
    };
    (0, react_1.useEffect)(function () {
        compareSize();
        // This will be helpful in mobile design, to hide/show tooltip.
        window.addEventListener('resize', compareSize);
        // remove resize listener again on "componentWillUnmount"
        return function () {
            window.removeEventListener('resize', compareSize);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(style_1.TooltipContainer, { children: [children, showTooltip && (0, jsx_runtime_1.jsx)(style_1.TooltipTitle, { children: content })] }));
};
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map